export type INVESTMENT_TYPE = 'SIP' | 'LUMP_SUM';
export type COMPOUNDING_FREQUENCY = 'MONTHLY' | 'FORTNIGHTLY' | 'QUARTERLY';

export interface IMUTUAL_FUND_FORMULA {
  investmentType: INVESTMENT_TYPE;
  investmentAmount: number;
  compoundingFrequency?: COMPOUNDING_FREQUENCY;
  rateOfReturn: number;
  sipTenure?: number;
  durationOfInvestment: number;
}

export const MUTUAL_FUND_FORMULA = ({
  investmentType,
  investmentAmount,
  compoundingFrequency,
  rateOfReturn,
  sipTenure,
  durationOfInvestment,
}: IMUTUAL_FUND_FORMULA) => {
  if (
    !investmentType ||
    !investmentAmount ||
    !rateOfReturn ||
    Number(rateOfReturn) < 0 ||
    (investmentType === 'LUMP_SUM' &&
      !(durationOfInvestment || Number(durationOfInvestment) < 0)) ||
    (investmentType === 'SIP' &&
      (!compoundingFrequency || !sipTenure || Number(sipTenure) < 0))
  ) {
    return {
      amountAtMaturity: 0,
    };
  }

  let amountAtMaturity = 0;

  if (investmentType === 'LUMP_SUM') {
    amountAtMaturity =
      Number(investmentAmount) *
      Math.pow(1 + Number(rateOfReturn) / 100, Number(durationOfInvestment));
  } else if (investmentType === 'SIP' && compoundingFrequency) {
    let periodsPerYear;

    switch (compoundingFrequency.toLowerCase()) {
      case 'monthly':
        periodsPerYear = 12;
        break;
      case 'fortnightly':
        periodsPerYear = 26;
        break;
      case 'quarterly':
        periodsPerYear = 4;
        break;
      default:
        periodsPerYear = 12;
    }

    const ci = rateOfReturn / 100 / periodsPerYear;
    const numberOfPayments = periodsPerYear * Number(sipTenure);

    amountAtMaturity =
      investmentAmount *
      ((Math.pow(1 + ci, numberOfPayments) - 1) / ci) *
      (1 + ci);
  }
  return {
    amountAtMaturity,
  };
};
